import create from 'zustand'

import {
  getMemberDetail,
  getMemberSubsquad,
  getMemberStatusesAPI,
  postCreateMemberAPI,
  postCreateDrdMemberAPI,
  getMemberRankingsAPI,
} from 'api/members'
import {
  MemberDetail,
  CreateMemberServiceTypes,
  CreateDrdMemberServiceTypes,
  MemberSubsquadDetail,
  MemberStatuses,
  MemberRankings,
  MemberIdentificationsTypes,
} from 'types/member'
import { StatusTypes, StatusErrorTypes } from 'types/status'

interface MemberStoreTypes {
  memberRankings: MemberRankings[]
  memberStatuses: MemberStatuses[]
  member: MemberDetail | undefined
  memberSubsquad: MemberSubsquadDetail | undefined
  memberCreateLoading: boolean
  memberCreateStatus: boolean
  memberTraderIdNewlyCreated: number | null
  drdMemberCreateLoading: boolean
  drdMemberCreateStatus: boolean
  drdMemberTraderIdNewlyCreated: number | null
  getMemberStatuses: (traderId: string) => void
  getMemberRankings: () => void
  getMember: (traderId: string) => void
  setMember: (member: MemberDetail) => void
  createMember: (payload: CreateMemberServiceTypes) => void
  createDrdMember: (payload: CreateDrdMemberServiceTypes) => void
  memberIdentificationsModErrors: StatusErrorTypes
  memberIdentificationsModErrorsSet: (
    memberIdentificationsModErrors: StatusErrorTypes
  ) => void
  memberIdentificationsModStatus: StatusTypes
  memberIdentificationsModStatusSet: (
    memberIdentificationsStatus: StatusTypes
  ) => void
  memberIdentifications: MemberIdentificationsTypes[]
  memberIdentificationsSet: (
    memberIdentifications: MemberIdentificationsTypes[]
  ) => void
}

const useMemberStore = create<MemberStoreTypes>((set) => ({
  memberRankings: [],
  memberStatuses: [],
  member: undefined,
  memberSubsquad: undefined,
  getMemberRankings: () => {
    getMemberRankingsAPI()
      .then((response) => {
        set({
          memberRankings: response.data,
        })
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        // console.log('')
      })
  },
  getMemberStatuses: (traderId: string) => {
    getMemberStatusesAPI({ traderId })
      .then((memberStatuses: MemberStatuses[]) => {
        set({
          memberStatuses,
        })
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        // console.log('')
      })
  },
  getMember: (traderId: string) => {
    getMemberDetail(traderId)
      .then((member: MemberDetail) => {
        set({
          member,
        })
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        // console.log('')
      })
    // getMemberSubsquad(traderId)
    //   .then((memberSubsquad: MemberSubsquadDetail) => {
    //     set({
    //       memberSubsquad,
    //     })
    //   })
    //   .catch((error) => {
    //     // eslint-disable-next-line no-console
    //     // console.log('')
    //   })
  },
  setMember: (member: MemberDetail) => {
    set({
      member,
    })
  },
  // start: Member Create
  memberCreateLoading: false,
  memberCreateStatus: false,
  memberTraderIdNewlyCreated: null,
  createMember: async (payload: CreateMemberServiceTypes) => {
    try {
      set({ memberCreateLoading: true })
      const member = await postCreateMemberAPI(payload)
      set({
        memberCreateLoading: false,
        memberCreateStatus: true,
        memberTraderIdNewlyCreated: member.data.traderId,
      })
    } catch (error) {
      set((state) => ({
        ...state,
        memberCreateStatus: false,
      }))
      throw error
    }
  },
  // end: Merchant Create  

  // start: DRD Member Create
  drdMemberCreateLoading: false,
  drdMemberCreateStatus: false,
  drdMemberTraderIdNewlyCreated: null,
  createDrdMember: async (payload: CreateDrdMemberServiceTypes) => {
    try {
      set({ drdMemberCreateLoading: true })
      const member = await postCreateDrdMemberAPI(payload)
      set({
        drdMemberCreateLoading: false,
        drdMemberCreateStatus: true,
        drdMemberTraderIdNewlyCreated: member.data.traderId,
      })
    } catch (error) {
      set((state) => ({
        ...state,
        drdMemberCreateStatus: false,
      }))
      throw error
    }
  },
  // end: Merchant Create  

  memberIdentificationsModErrors: '',
  memberIdentificationsModErrorsSet: (memberIdentificationsModErrors) => {
    set({
      memberIdentificationsModErrors,
    })
  },
  memberIdentificationsModStatus: 'idle',
  memberIdentificationsModStatusSet: (memberIdentificationsModStatus) => {
    set({
      memberIdentificationsModStatus,
    })
  },
  memberIdentifications: [],
  memberIdentificationsSet: (memberIdentifications) => {
    set({
      memberIdentifications,
    })
  },
}))

export default useMemberStore
